module.exports = __webpack_public_path__ + "img/assisting_livings.cc84db49.jpg";